import {
  addSeconds,
  addWeeks,
  differenceInMinutes,
  differenceInDays,
  differenceInYears,
  endOfMonth,
  endOfDay,
  format,
  formatDistance,
  getDaysInMonth,
  getWeekOfMonth,
  getHours,
  getMinutes,
  getDay,
  getWeek,
  getWeekYear,
  getMonth,
  getQuarter,
  getYear,
  setYear,
  setWeek,
  setWeekYear,
  setMonth,
  setQuarter,
  isSameDay,
  isSameMonth,
  isSameYear,
  parse,
  startOfMonth,
  startOfWeek,
  startOfISOWeek,
  startOfDay,
  startOfYear,
  startOfWeekYear,
  startOfQuarter,
  endOfWeek,
  endOfYear,
  subDays,
} from 'date-fns'

const dateFnsHelpers = {
  addSeconds,
  addWeeks,
  differenceInMinutes,
  differenceInDays,
  differenceInYears,
  endOfMonth,
  endOfDay,
  format,
  formatDistance,
  getDaysInMonth,
  getWeekOfMonth,
  getHours,
  getMinutes,
  getDay,
  getWeek,
  getWeekYear,
  getMonth,
  getQuarter,
  getYear,
  setYear,
  setWeek,
  setWeekYear,
  setMonth,
  setQuarter,
  isSameDay,
  isSameMonth,
  isSameYear,
  parse,
  startOfMonth,
  startOfWeek,
  startOfISOWeek,
  startOfDay,
  startOfYear,
  startOfWeekYear,
  startOfQuarter,
  endOfWeek,
  endOfYear,
  subDays,
}

export type DateFnsHelpers = typeof dateFnsHelpers

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide('dateFns', dateFnsHelpers)
})
